import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';
import {collections} from '../data/products';

const {FiArrowUpRight} = FiIcons;
const waLink = (text) => `https://wa.me/919876543210?text=${encodeURIComponent(text)}`;

function CollectionSection() {
  return (
    <section id="collections" className="bg-[#EDE4D3] py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="eyebrow eyebrow-center mb-5" style={{color: '#1F3D2E'}}>Curated edits</p>
          <h2 className="font-display text-[clamp(36px,5vw,64px)] leading-tight text-[#1F1B17] font-light">
            Three ways to <em className="italic text-[#1F3D2E]">begin</em>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {collections.map((c,i) => (
            <motion.a key={c.title} href={waLink(`Hi Aurelle! I would love to see the ${c.title}.`)} target="_blank" rel="noreferrer" initial={{opacity: 0,y: 40}} whileInView={{opacity: 1,y: 0}} viewport={{once: true,amount: 0.2}} transition={{delay: i * 0.12,duration: 0.6}} className="group relative block aspect-[3/4] overflow-hidden">
              <img src={c.image} alt={c.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1F1B17]/75 via-transparent to-transparent" />
              <div className="absolute top-6 left-6">
                <span className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#F7F2EA] bg-[#1F3D2E]/80 px-3 py-1.5">{c.label}</span>
              </div>
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <h3 className="font-display text-3xl text-[#F7F2EA] font-light">{c.title}</h3>
                <span className="grid place-items-center w-11 h-11 rounded-full border border-[#F7F2EA]/50 text-[#F7F2EA] transition group-hover:bg-[#B87333] group-hover:border-[#B87333] group-hover:text-[#1F1B17]">
                  <SafeIcon icon={FiArrowUpRight} />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CollectionSection;
